import { GlobalSettings } from 'app/appState';
import { User, UserAccountType } from '../../model/types';

export const checkUserDataComplete = (
  userData: Nullable<User>,
  accountType?: UserAccountType,
  globalSettings?: Nullable<GlobalSettings>,
): boolean => {
  if (!userData) {
    return false;
  }

  const isCustomerIdentificationNumberRequired = globalSettings?.isCustomerIdentificationNumberRequired;

  const {
    userId,
    firstName,
    lastName,
    phone,
    dateOfBirth,
    street,
    house,
    zip,
    email,
    country,
    city,
    language,
    accountType: userDataAccountType,
    role,
    company,
    identificationNumber,
  } = userData;

  let hasEmptyFields =
    !userId ||
    !firstName ||
    !lastName ||
    !phone ||
    !street ||
    !house ||
    !zip ||
    !email ||
    !country ||
    !city ||
    !language ||
    !userDataAccountType ||
    !role;

  if (isCustomerIdentificationNumberRequired) {
    hasEmptyFields = hasEmptyFields || !identificationNumber;
  }

  if (accountType === UserAccountType.BUSINESS) {
    hasEmptyFields = hasEmptyFields || !company;
  }

  return !hasEmptyFields;
};
